/* FUNCTIONS */

function traiterPositionScroll() {
    if ($(window).scrollTop() != 0) {
        // without this timeout, the class is added too early and we see the black
        // logo while the header is still transitioning out of the top of the page
        setTimeout(function () {
            $('#jami-header').removeClass("top-page");
        }, 200);
    } else {
        setTimeout(function () {
            $('#jami-header').addClass("top-page");
        }, 200);
    }

    if ($('#jami-header').hasClass("top-page")) {
        traiterHeaderPosition();
    } else {
        $(".jami-header").css("top", 0);
    }
}

let lastScrollTop = 0;
function handleScrollDown() {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    let floatingHeader = document.getElementById("floating-header");
    if (currentScroll > lastScrollTop) {
        // Scrolling down
        if (floatingHeader !== null) {
            floatingHeader.classList.remove("scroll-up");
        }
        $('#jami-header').addClass("scroll-down");
    } else {
        // Scrolling up
        if (floatingHeader !== null) {
            floatingHeader.classList.add("scroll-up");
        }
        $('#jami-header').removeClass("scroll-down");
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
}

function traiterRemoveClassPanelUnknow() {
    $("html").removeClass("language-not-translate");
    $(".jami-header.top-page").css("top", 0);
}

function traiterHeaderPosition() {
    if ($("html").hasClass("language-not-translate")) {
        var panelUnknowHeight = $(".panel-unknow").height() + 40;
        $(".jami-header.top-page").css("top", panelUnknowHeight);
    } else {
        $(".jami-header.top-page").css("top", 0);
    }
}

function traiterTransifexFetchLang() {

    Transifex.live.onFetchLanguages(function (language_code) {
        var browserLang = navigator.language,
            nameLang = Transifex.live.getLanguageName(browserLang);

        if (nameLang == undefined) {
            var browserLangValueTransifex = browserLang.substring(0, 2),
                nameLangCode = Transifex.live.getLanguageName(browserLangValueTransifex);

            if (nameLangCode == undefined) {
                $("html").addClass("language-not-translate");
            } else {
                $("html").addClass("language-is-translate");
            }
        } else {
            $("html").addClass("language-is-translate");
        }
    });

    traiterHeaderPosition();

    $('.nav_transifex-lang .ic-arrowright').click(function () {
        $('#tx-live-lang-toggle').trigger("click");
    });

    $('#btn-cancel-popup-unknow-lang').click(function () {
        traiterRemoveClassPanelUnknow();
        Cookies.set('unknow_lang', 'popup_cookie');
    });

    // Close the language selector when clicking outside of it
    document.addEventListener('click', function (event) {
        langSelectorListOpened = document.querySelector('.txlive-langselector-list-opened');
        transifexComponent = document.querySelector('.donate-btn-langselector');
        // Check that the language list is opened and that the click is outside of the language selector
        if (langSelectorListOpened != null && event.target !== transifexComponent && !transifexComponent.contains(event.target)) {
            $('#tx-live-lang-toggle').trigger("click");
        }
    });
}

if (Cookies('unknow_lang')) { /*if cookie isset*/
    /*do stuff here like hide a popup when cookie isset*/
    traiterRemoveClassPanelUnknow();
}

/* INIT CALL FUNCTION */
traiterPositionScroll();
traiterTransifexFetchLang();

$(window).scroll(function () {
    traiterPositionScroll();
    handleScrollDown();
});

$(window).resize(function () {
    traiterHeaderPosition();
});

/* SLIDER */

$('.slider-infopresse').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    centerPadding: '60px',
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

$('.slider-features').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    centerPadding: '60px',
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.card').click(function () {
    $(this).toggleClass('is-flipped');
});

$('.nav-services > a').attr("target", "_blank");

/**
 * The following function moves the target element under different parent based on screen size. Because target wireframe layout is not the same on different screen size.
 * We can't just simply use 2 duplicate elements and toggle their display because the target element is a language selector that is also handled by 
 * a 3rd party module using `id` property. Having such element in the DOM more than one time will cause UI issue
*/
function handleLanguageSelectorOnWindowSizeChange() {
    let windowWidth = $(window).width();

    let container_non_mobile = $('.jami-footer__donate-btn-langselector');
    let container_mobile = $('.jami-footer__donate-btn-langselector__mobile');

    if (windowWidth < 768) {
        container_non_mobile.children().appendTo('.jami-footer__donate-btn-langselector__mobile');
    } else {
        container_mobile.children().appendTo('.jami-footer__donate-btn-langselector');
    }
}

$(window).on('resize', function () {
    handleLanguageSelectorOnWindowSizeChange();
});

// Update the browser URL without updating the page
function UpdateBrowserEntryWithoutReload() {
  const nextTitle = 'My new page title';
  const nextState = { additionalInformation: 'Updated the URL with JS' };

  // Get the current URL
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  // Check if "?lang=xx" is in the URL
  if (params.has('lang')) {
    const lang = params.get('lang');
    params.delete('lang'); // Remove lang from query params

    // Extract the current pathname
    let path = url.pathname.replace(/^\/+/, ''); // Remove leading slashes
    let pathParts = path.split('/');

    // Check if the first part of the path is already a language code
    if (/^[a-z]{2}$/.test(pathParts[0])) {
      pathParts[0] = lang; // Replace the existing language with the new one
    } else {
      pathParts.unshift(lang); // Prepend the new language if none exists
    }

    // Construct the new URL
    const nextURL = `/${pathParts.join('/')}${params.toString() ? '?' + params.toString() : ''}`;

    // Replace the current entry in the browser's history, without reloading
    window.history.replaceState(nextState, nextTitle, nextURL);
  }
}

//Make sure it runs after refreshing the page
$(document).ready(function () {
    handleLanguageSelectorOnWindowSizeChange();
    let fullPathname = window.location.pathname;
    let currentPathname = getCurrentUrlWithoutLang(fullPathname);
    // setDefaultLangToEnglish(fullPathname)
    UpdateBrowserEntryWithoutReload();
    reloadPageOnLangChanged(currentPathname);
    overridePageUrlToAddLang()
})

function setDefaultLangToEnglish(fullPathname) {
    const regex = /^\/[a-z]{2}\//g;
    let found = fullPathname.match(regex);
    if (!found) {
        // change language to english, if url === / or /slug.. and !== /lang or /lang/...
		Transifex.live.translateTo("en");
    }
}

function overridePageUrlToAddLang() {
    $('a').each(function() {
        overrideUrl(this)
    });
}

function overrideUrl(link) {
    let selectedLangCode = Transifex.live.getSelectedLanguageCode();
    let href = $(link).attr('href');
    let newHref = null;
    // Check if the href is not null or undefined and it's not an external link
    if (!href) {
		return null;
    }
    if (href.startsWith('http') && (href.includes('https://jami.net') || href.includes('https://staging.jami.net'))) {
        newHref = href.replace(/^(https?:\/\/[^\/]+\/)/, '$1' + selectedLangCode + '/');
        $(link).attr('href', newHref);
    } else if (href.startsWith('/')) {
        href = getCurrentUrlWithoutLang(href);
        newHref = "/" + selectedLangCode + href;
        $(link).attr('href', newHref);
    }
}

function getCurrentUrlWithoutLang(fullPathname) {
	let languages = Transifex.live.getAllLanguages();
    let isPathnameContainLang = languages.find(lang => '/'+lang.code+'/' === fullPathname.substring(0, 4))
    const regex = /^\/[a-z]{2}\//g;
    let found = fullPathname.match(regex);
    // Using regex to get /lang from fullPathname is not found in language lkie /no -> /no_NO
    isPathnameContainLang = isPathnameContainLang ? isPathnameContainLang : found
    // Ex: convert /fr/post-or-page-slug to /post-or-page-slug
    if (fullPathname.length == 4 && isPathnameContainLang) {
        return '' 
    }
	currentPathname = isPathnameContainLang ? fullPathname.substring(3) : fullPathname;
	return currentPathname;
}

// reload page using selected language
function reloadPageOnLangChanged(currentPathname) {
    $('#transifex-language #tx-live-lang-picker').find("button").click(function () {
        window.location.href = window.location.protocol + '//' + window.location.hostname + '/' + Transifex.live.getSelectedLanguageCode() + currentPathname + window.location.hash
        $('#tx-live-lang-toggle').trigger("click");
    });
}

// Extensions page
// Making sure one collapsible is expanded at a time, the rest should be closed.

let checkboxes = document.querySelectorAll('.page-extensions .collapsible .collapsible-toggle');

// Loop through each checkbox
for (let i = 0; i < checkboxes.length; i++) {
    // Attach click event listener
    checkboxes[i].addEventListener('click', function () {
        // When clicked, loop through checkboxes again
        for (let j = 0; j < checkboxes.length; j++) {
            // If it's not the checkbox that was clicked, uncheck it
            if (checkboxes[j] !== this) {
                checkboxes[j].checked = false;
            }
        }
    });
}


// Show underline for download button in the nav when on download related pages. Not just `/download`
document.addEventListener('DOMContentLoaded', function () {
    let currentURL = window.location.href;
    if (currentURL.indexOf('download') !== -1) {
        $('li.nav-download a').css('transition', 'unset');
        $('li.nav-download').addClass('nav-current');
    }
})

// Function to handle why donate anchor clicks
function handleLinkClick(clickedAnchor) {
    // Remove the .last-clicked class from all links
    const anchor = document.querySelectorAll('.why-donate-anchor');
    anchor.forEach(anchor => anchor.classList.remove('last-clicked-anchor'));
    // Add the .last-clicked class to the clicked link
    clickedAnchor.classList.add('last-clicked-anchor');
}

// Add click event listeners to all anchor anchor
document.addEventListener('DOMContentLoaded', function () {
    const anchors = document.querySelectorAll('.why-donate-anchor');
    anchors.forEach(anchor => {
        anchor.addEventListener('click', function (event) {
            handleLinkClick(event.target);
        });
    });
});

// Set active class to the blog nav on page load
$(document).ready(function () {
    // Execute only if the URL path starts with "/tag"
    if (window.location.pathname.startsWith('/tag')) {
        let bodyClasses = document.body.className.split(' ');
        let tagClasses = bodyClasses.filter(cls => cls.startsWith('tag-'));
        if (tagClasses.length >= 2) {
            let id = tagClasses[1].split('-')[1];
            // Use the variable part as an ID to select the element
            let element = document.getElementById(id);
            if (element !== null) {
                element.classList.add('active');
            }
        }
    }
});

$(window).on('resize', function () {
    // Get the current width and height of the window
    let width = $(window).width();
    let height = $(window).height();

    // Set the width and height of the lightbox overlay
    $('.lightboxOverlay').css({
        'width': width,
        'height': height
    });
});

// Newsletter related functions
function isValidEmail(email) {
    // Ensure input type is string to prevent unexpected type error
    if (typeof email !== 'string') {
        return false;
    }

    // Trim any excess whitespace from the start and end
    const trimmedEmail = email.trim();

    // Regex to validate email address
    // - The local part: one or more word characters, hyphens, or dots, but not starting or ending with a hyphen or dot.
    // - The "@" symbol.
    // - The domain: one or more word characters, with dots separating domain levels.
    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

    // Test the regex against the email address
    return emailRegex.test(trimmedEmail);
}

function mailchimpFormChanged(event) {
    event.preventDefault();
    // Get the form that triggered the onsubmit event
    let form = event.target.form;
    validateMailchimpForm(form);
}

// Function to handle mailchimp form changes
function validateMailchimpForm(form) {
    let mailchimpConfirmBtn = form.querySelector('#mc-embedded-subscribe');
    var emailInput = form.querySelector("#mce-EMAIL");
    var email = emailInput.value;
    var checkBox = form.querySelector("#email-authorization");
    if (isValidEmail(email) && checkBox.checked) {
        mailchimpConfirmBtn.removeAttribute('disabled');
    } else {
        mailchimpConfirmBtn.setAttribute('disabled', '');
    }
}

// Handle the popover click behavior on the newsletter sticky button
var newsletterPopoverOpened = false;
$('#newsletter-sticky-button, #newsletter-sticky-popover').click(function (event) {
    let stickyWrapper = document.getElementById('newsletter-sticky-popover');
    if (newsletterPopoverOpened && !stickyWrapper.contains(event.target)) {
        $('#newsletter-sticky-popover').removeClass('show-form');
        $('#newsletter-sticky-button').removeClass('show-form');
        newsletterPopoverOpened = false;
    } else {
        $('#newsletter-sticky-popover').addClass('show-form');
        $('#newsletter-sticky-button').addClass('show-form');
        newsletterPopoverOpened = true;
    }
});

// Close the popover when clicking outside of it
$(document).on('click', function (event) {
    let stickyWrapper = document.getElementById('newsletter-sticky-wrapper');
    if (!stickyWrapper.contains(event.target) && newsletterPopoverOpened) {
        $('#newsletter-sticky-popover').removeClass('show-form');
        $('#newsletter-sticky-button').removeClass('show-form');
        newsletterPopoverOpened = false;
    }
});
